import { Injectable } from '@angular/core';
declare const angular: any;

@Injectable({
  providedIn: 'root'
})
export class MainDocumentListService {
  ajsService: any;

  constructor(
    ) {
      const element = document.querySelectorAll('div[ui-view]');
      const injector = angular.element(element).injector();

      this.ajsService = injector.get('MainDocumentListService');
  }

  /**
   * get the main document info
   */
  getMainDocumentListId() {
    return this.ajsService.getMainDocumentInfo().documentListId;
  }
}
